export default __webpack_public_path__ + "static/media/screenshot24.22d405aa.jpg";